import { render, staticRenderFns } from "./PatientListView.vue?vue&type=template&id=1c2c7cf5&scoped=true"
import script from "./PatientListView.vue?vue&type=script&lang=js"
export * from "./PatientListView.vue?vue&type=script&lang=js"
import style0 from "./PatientListView.vue?vue&type=style&index=0&id=1c2c7cf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c7cf5",
  null
  
)

export default component.exports